import React from 'react';
import TierGrid from '../TierGrid';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import LoadingIndicator from '../../../LoadingIndicator';
import { useTiers } from '../../_hocs/withTiers';
import { MeasuredCookieType } from '../../../Measured';
import TierPromotionCard from '../../../DeviationViews/TierPromotionCard';
import SelectableDeviationWrapper from '../../_partials/SelectableDeviationWrapper';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
var TierSelector = function () {
    var _a = useTiers(), tiers = _a.tiers, isTierStreamInitialized = _a.isTierStreamInitialized, isFetchingTiers = _a.isFetchingTiers;
    var renderTier = function (_a) {
        var index = _a.index, width = _a.width;
        var tier = tiers[index];
        return (React.createElement(SelectableDeviationWrapper, { key: getDeviationEntityId(tier), deviation: tier },
            React.createElement(TierPromotionCard, { width: width, deviation: tier })));
    };
    var renderContent = function () {
        return (React.createElement(React.Fragment, null,
            isTierStreamInitialized && (React.createElement(TierGrid, { cookieType: MeasuredCookieType.GALLECTION_EXPLORER, tiers: tiers, tierRenderer: renderTier })),
            isFetchingTiers && (React.createElement(LoadingIndicator, { view: "daSymbol", coverMode: !tiers.length }))));
    };
    return React.createElement(PopupInnerLayout, { scrollableContent: renderContent() });
};
TierSelector.displayName = 'TierSelector';
export default TierSelector;
//# sourceMappingURL=TierSelector.js.map